import { createElement } from "react";
async function AsyncComponentWrapper({
  Component,
  componentProps,
  key,
  shouldAwait
}) {
  if (shouldAwait) {
    return await Component(componentProps);
  }
  return /* @__PURE__ */ createElement(Component, { ...componentProps, key });
}
export {
  AsyncComponentWrapper
};
